import { motion } from "framer-motion";
import { ShieldCheck, Wrench, AlertTriangle, Flame, Wind, BadgeCheck } from "lucide-react";
import { TIPS } from "@/data/content";

const ICONS = { ShieldCheck, Wrench, AlertTriangle, Flame, Wind, BadgeCheck };
const COLORS = {
  indigo: "bg-[#eef1ff] text-[#1d3fd9]",
  green: "bg-[#eefbd6] text-[#5a8b00]",
  red: "bg-[#ffeceb] text-[#e23b32]",
};

const Tips = () => {
  return (
    <section id="dicas" data-testid="tips-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-[#1d3fd9] font-bold tracking-widest text-sm mb-4">SEGURANÇA</p>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0f1733] tracking-tight">Dicas de Segurança</h2>
          <p className="text-slate-500 text-lg mt-5">
            Confira nossas dicas para manusear e armazenar seu botijão de gás com total segurança.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TIPS.map((tip, i) => {
            const Icon = ICONS[tip.icon];
            return (
              <motion.div
                key={tip.title}
                data-testid={`tip-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                className="border border-slate-100 rounded-3xl p-8 hover:shadow-xl hover:border-transparent transition-all duration-300"
              >
                <span className={`flex items-center justify-center w-14 h-14 rounded-2xl ${COLORS[tip.color]}`}>
                  <Icon className="w-7 h-7" />
                </span>
                <h3 className="text-xl font-extrabold text-[#0f1733] mt-6">{tip.title}</h3>
                <p className="text-slate-500 mt-3 leading-relaxed">{tip.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Tips;
